// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--11E64","item":"dece2e673c--item--2lSDO","icon":"dece2e673c--icon--2k2Sx","text":"dece2e673c--text--sN4ci"};